import { render, staticRenderFns } from "./eventEvaluation.vue?vue&type=template&id=c8ff65f4&scoped=true&"
import script from "./eventEvaluation.vue?vue&type=script&lang=js&"
export * from "./eventEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./eventEvaluation.vue?vue&type=style&index=0&id=c8ff65f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff65f4",
  null
  
)

export default component.exports